"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerTabItem = exports.BmTabItem = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<slot></slot>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcontain: content;\n\t\tpadding: 13px 20px;\n\t\ttext-transform: uppercase;\n\t\tbackground-color: #f4f5f7;\n\t\tcolor: #606169;\n\t\tborder: 1px solid #b2b2b8;\n\t\toverflow: hidden;\n\n\t\tfont-size: 11px;\n\t\tfont-family: KnowledgeMedium, arial, helvetica, sans-serif;\n\t\tfont-weight: 400;\n\t}\n\n\t:host([active]) {\n\t\tborder-color: #37383d;\n\t\tbackground-color: #37383d;\n\t\tcolor: #fff;\n\t}\n\n\t:host(:not([active])) {\n\t\tcursor: pointer;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmTabItem = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmTabItem, _BlueElement);

  var _super = (0, _createSuper2.default)(BmTabItem);

  function BmTabItem() {
    (0, _classCallCheck2.default)(this, BmTabItem);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmTabItem, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2());
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-tab-item';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        name: {
          type: String,
          attribute: true,
          reflect: true
        },
        active: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmTabItem;
}(_element.BlueElement);

exports.BmTabItem = BmTabItem;

var registerTabItem = function registerTabItem() {
  return (0, _element.register)(BmTabItem);
};

exports.registerTabItem = registerTabItem;
